import { FILTER } from "@/constants";
import CheckboxSelect from "@/containers/Filters/CheckboxSelect";
import FilterCountIndicator from "@/containers/Filters/FilterCountIndicator";
import useFilterCount from "@/containers/Filters/hooks/useFilterCount";
import { FilterOption } from "@/types/FilterOptions";
import { Accordion } from "@components/Accordion";

import useOptionLabel from "../../hooks/useOptionLabel";

export type LanguageProps = {
  options: FilterOption[];
};

const Language: React.FunctionComponent<LanguageProps> = ({ options }) => {
  const preview = useOptionLabel(FILTER.LANGUAGE, options);
  const count = useFilterCount(FILTER.LANGUAGE);

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <Accordion
      value="language"
      data-testid="filter-bar--language"
      title={L.MENTIONS_VIEW_TOOLBAR_FILTER_LANGUAGES_LABEL}
      indicator={<FilterCountIndicator count={count} />}
      preview={preview}
    >
      <CheckboxSelect name={FILTER.LANGUAGE} options={options} />
    </Accordion>
  );
};

export default Language;
